export default "__VITE_ASSET__DyqIz21a__"